export default __webpack_public_path__ + "static/media/breast_example_2.54d10478.png";